module.exports = __webpack_public_path__ + "54a9ffad9015e018a59d70efae436aa2.png";